import React, { useEffect, useState } from "react";
import { fetchQuote } from "./api";
import QuoteCard from "./QuoteCard";
import HeroLink from "./HeroLink";
import RoryCourses from "./RoryCourses";
import SignupBox from "./SignupBox";
import Sources from "./Sources";
import { RoryQuote } from "./types";

// One quote's own page: the address people share, and what search engines
// find. The card is the same as on the finder.
const Show = (props: any) => {
  const slug: string = props.match?.params?.slug;
  const [quote, setQuote] = useState<RoryQuote | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setQuote(null);
    fetchQuote(slug)
      .then(setQuote)
      .catch(() => setError("That quote could not be found."));
  }, [slug]);

  return (
    <div className="rq">
      <section className="rq-hero">
        <div className="rq-wrap rq-hero__inner">
          <header className="rq-hero__head">
            <span className="rq-hero__avatar">
              <img src="/rory-quotes/rory-sketch.png" alt="A hand-drawn ink sketch of Rory Sutherland" width="112" height="112" />
            </span>
            <div className="rq-hero__copy">
              <p className="rq-eyebrow rq-eyebrow--blue">A Rory Sutherland quote</p>
              <h1 className="rq-hero__title rq-hero__title--small">
                From the Rory Quote <em>Finder</em>
              </h1>
            </div>
            <HeroLink to="/rory-quotes/top">Top 10 quotes</HeroLink>
          </header>
          <div className="rq-finder">
            {quote ? (
              <QuoteCard quote={quote} linkToPage={false} />
            ) : (
              <div className="rq-card rq-card--loading">{error || "One moment…"}</div>
            )}
            <div className="rq-finder__acts">
              <a href="/rory-quotes" className="rq-btn rq-btn--blue">
                Find another quote
              </a>
              <a href="/rory-quotes/top" className="rq-finder__toggle">
                See the top ten
              </a>
            </div>
          </div>
        </div>
      </section>
      <SignupBox />
      <RoryCourses />
      <Sources />
    </div>
  );
};

export default Show;
